import { Element } from 'react-scroll';
import { DEFAULT_TOP_MARGIN_IN_PIXELS } from './HashAnchor.contants';
import { HashAnchorProps } from './HashAnchor.types';

export const HashAnchor: React.FC<HashAnchorProps> = ({
  name,
  top = DEFAULT_TOP_MARGIN_IN_PIXELS
}) => (
  <Element
    name={name}
    id={name}
    style={{
      position: 'relative',
      top: `${top}px`,
      display: 'block',
      visibility: 'hidden'
    }}
  />
);
